export default "__VITE_ASSET__M_pGKDC1__"